<div class="manage-fund-container">
  <div class="container-fluid px-1">
    <div class="row">
      <div class="col-12">
        <div class="toggle-actions-blk my-2">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              class="btn btn-outline-primary"
              [ngClass]="{ active: isAddFunds }"
              (click)="onAddFunds()"
            >
              <span translate class="translate">pages.newRetailer.add</span>
            </button>
            <button
              type="button"
              class="btn btn-outline-primary"
              [ngClass]="{ active: isRemoveFunds }"
              (click)="onRemoveFunds()" 
            >
              <span translate class="translate">pages.newRetailer.remove</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-card class="p-2 shadow">
    <form
      (ngSubmit)="onManageFundsSubmit()"
      [formGroup]="manageRetailerFundsForm"
    >
      <div class="form-inner content-details-blk">
        <mat-radio-group
          [formControl]="retailerRadioControl"
          (change)="selectedAccountType($event)"
        >
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <mat-radio-button color="primary" value="retailer"
                >{{'pages.Managefunds.Retailer' | translate }}</mat-radio-button
              >
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{'pages.AutoReload.RetailerName' | translate }} </mat-label>
                  <input
                    type="text"
                    placeholder="Pick one"
                    aria-label="Number"
                    matInput
                    formControlName="retailerName"
                    [matAutocomplete]="auto1"
                  />
                  <mat-autocomplete  panelWidth="250px" 
                    #auto1="matAutocomplete"
                    (optionSelected)="selectedRetailerDetails($event)"
                    [displayWith]="getOptionretailerName"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptions"
                      [value]="option"
                    >
                      {{ option.retailerName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{'pages.Managefunds.RetailerAccountNumber' | translate }}</mat-label>
                  <input
                    type="text"
                    placeholder="Pick one"
                    aria-label="Number"
                    matInput
                    formControlName="accountNumber"
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete  
                    #auto="matAutocomplete"
                    (optionSelected)="selectedRetailerAcountDetails($event)"
                    [displayWith]="getOptionText"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptionsbyaccount"
                      [value]="option"
                    >
                      {{ option.retailerAccountNum }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-radio-button color="primary" value="salesRep"
                  >{{'pages.Managefunds.Salesrep' | translate }}</mat-radio-button
                >
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{'pages.Managefunds.Salesrepname' | translate }} </mat-label>
                  <input
                    type="text"
                    aria-label="salesRepName"
                    matInput
                    placeholder="Enter Sales Rep Name"
                    formControlName="salesRepName"
                    [matAutocomplete]="auto3"
                  />
                  <mat-autocomplete  panelWidth="250px" 
                    #auto3="matAutocomplete"
                    (optionSelected)="selectedSalesRepDetails($event)"
                    [displayWith]="getOptionSalesrepName"
                  >
                    <mat-option
                      *ngFor="let option of filteredSalesrepOptions"
                      [value]="option"
                    >
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-radio-group>

        <div class="row my-2">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              <span translate class="translate"
                >pages.newRetailer.accountType</span
              >
            </h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="{{
                    'pages.newRetailer.accountType' | translate
                  }}"
                  formControlName="retailerType"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label">{{'pages.ManageProviders.Mobilenumber' | translate }}</h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="{{'pages.ManageProviders.Mobilenumber' | translate }}"
                  formControlName="otpMobileNumber"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row my-2">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.businessname
            </h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="{{ 'pages.newRetailer.businessname' | translate }}"
                  formControlName="businessName"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>pages.newRetailer.dbaName</h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="{{ 'pages.newRetailer.dbaName' | translate }}"
                  formControlName="dbaName"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row my-2">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>pages.newRetailer.address</h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field class="" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="{{'pages.AddProviders.Enteraddress' | translate }} Line1"
                  formControlName="address1"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.amount <span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field class="" appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: numberMask, guide: false }"
                  required
                  (input)="onAmountChange($event.target.value)"
                  placeholder="{{'pages.Managefunds.Enteramount' | translate }}"
                  formControlName="amount"
                />
              </mat-form-field>
              <div *ngIf="f.amount.touched && f.amount.invalid">
                <div *ngIf="f.amount.errors.required; else invalid">
                  <mat-hint class="text-danger ms-2">
                    Amount Is Required.</mat-hint
                  >
                </div>
                <ng-template #invalid>
                  <mat-hint class="text-danger ms-2">
                    Invalid Amount Entered.</mat-hint
                  >
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div class="row my-2">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.availableCreditBalance
            </h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field class="" appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: numberMask, guide: false }"
                  placeholder="{{'pages.Managefunds.EnterCreditbalance' | translate }}"
                  formControlName="currentAmount"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.newBalance
            </h4>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field class="" appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: numberMask, guide: false }"
                  placeholder="{{'pages.Managefunds.Enterbalance' | translate }}"
                  formControlName="newBalance"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="form-footer mb-4">
        <ul class="list-inline text-center">
          <li class="list-inline-item">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="rounded-0"
              [disabled]="checkSubmitDisplayed()" 
              
            >
              <span translate *ngIf="isAddFunds"
                >pages.newRetailer.addFunds</span
              >
              <span translate *ngIf="isRemoveFunds"
                >pages.newRetailer.removeFunds</span
              >
            </button>
          </li>
          <li class="list-inline-item">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="rounded-0"
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </li>
          <li class="list-inline-item"></li>
        </ul>
      </div>
    </form>
  </mat-card>
</div>
